import { createContext, useContext } from 'react'

const AgentContext = createContext({
  openAgent: () => {},
  openAgentFullscreen: () => {},
  setFabDialogue: () => {},
  suppressFab: () => {},
  isAgentFullscreen: false,
  closeAgentFullscreen: () => {},
  // v206.2: Home chat session
  homeSessionActive: false,
  startHomeSession: () => {},
  clearHomeSession: () => {},
})

export const AgentProvider = AgentContext.Provider
export const useAgent = () => useContext(AgentContext)
